var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.indexPage,{ref:"indexPageRef",attrs:{"path":_setup.path,"name":_setup.name,"reportClass":_setup.reportClass},on:{"set-loading":_setup.setLoading,"open-issue-form":_setup.openIssueForm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }